import { ArrowUpRight } from "lucide-react";

/**
 * Contextual closing CTA — page-specific copy, single clear action.
 */
export default function ContextualCTA({ testid, heading, body, label, onBook }) {
  return (
    <section data-testid={testid} className="py-20 md:py-24 bg-[#050505] text-white">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 text-center">
        <p className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-snug">
          {heading}
        </p>
        {body && <p className="mt-5 text-white/70 leading-relaxed">{body}</p>}
        <button
          data-testid={`${testid}-btn`}
          onClick={onBook}
          className="group mt-8 inline-flex items-center gap-3 h-12 px-7 bg-white text-black text-[15px] font-medium hover:bg-zinc-200 transition-colors duration-300"
        >
          {label}
          <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </button>
      </div>
    </section>
  );
}
